<app-header></app-header>
<div class="container-fluid mt-3">
    <router-outlet></router-outlet>
</div>
<p-toast [style]="{marginTop: '80px'}" position="bottom-center"></p-toast>
<p-confirmDialog #cd header="Подтвердите действие" icon="pi pi-question">
    <p-footer>
        <button type="button" pButton icon="pi pi-check" label="Да" class="p-button-primary"
            (click)="cd.accept()"></button>
        <button type="button" pButton icon="pi pi-ban" label="Нет" class="p-button-secondary"
            (click)="cd.reject()"></button>
    </p-footer>
</p-confirmDialog>
